import React from 'react';
import comingSoonMessages, {
	ComingSoonMessages,
} from '../../lib/comingSoonMessages';

/**
 * @usePostData
 * @post_type location
 */
export interface ILocationTileProps {
	title?: string;
	permalink?: string;
	address?: string;
	phone?: string;
	/**
	 * Set when the location, or a service at it, has not opened yet. A tile shows no hours,
	 * so this is the only thing telling a donor not to drive over with a carload.
	 */
	comingSoon?: ComingSoonMessages;
}

const LocationTile: React.FC<ILocationTileProps> = ({
	title,
	permalink,
	address,
	phone,
	comingSoon,
}) => (
	<div className="location-tile">
		<div className="location-tile__inner">
			{title && (
				<h3 className="location-tile__title">
					{permalink ? <a href={permalink}>{title}</a> : title}
				</h3>
			)}
			{comingSoonMessages(comingSoon).map((message, messageIndex) => (
				<p className="location-tile__coming-soon" key={messageIndex}>
					{message}
				</p>
			))}
			{address && (
				<address
					className="location-tile__address"
					dangerouslySetInnerHTML={{
						__html: address.replace(/\\n/g, '<br />'),
					}}
				/>
			)}
			{phone && (
				<a href={`tel:${phone}`} className="location-tile__phone">
					{phone}
				</a>
			)}
		</div>
	</div>
);

export default LocationTile;
